import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { 
    Grid, 
    Button, 
    Input, 
    Popup, 
    Icon, 
    Modal, 
    Form,
    Dropdown 
} from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { getClientTimezone, toUTC } from "../../../../utils/format";
import { deleteCalendarEvents } from "../../../../actions/adminConsole";
import { getSafeSelectedWorkspace } from "../../../../utils/mappers/user";
import { getTodayFormatted } from "../../../../utils/format";
import { mapCurrentUserToWorkspaceOptions } from "../../../../utils/mappers/workspace";

export const DeleteCalendarEvents = ({
    currentWorkspaceId,
    deleteCalendarEvents,
    workspaces,
    currentUser,
}) => {
    const { t } = useTranslation();

    const [workspaceSelected, setWorkspaceSelected] = useState(currentWorkspaceId)
    
    const [ deleteAction, setDeleteAction ] = useState(false)
    const [ workspaceNameError, setWorkspaceNameError] = useState()
    const [ fromDate, setFromDate ] = useState("");
    const [ toDate, setToDate ] = useState("");

    const workspaceTimeZone = getClientTimezone()
    const today = getTodayFormatted()

    const handleFromDateChange = (e) => {
        const value = e.target.value
        if (value > today) {
            return;
        }
        setFromDate(value);
        if (toDate && value > toDate) {
            setToDate("");
        }
    };

    const handleToDateChange = (e) => {
        const value = e.target.value
        console.log(value)
        if (fromDate && value < fromDate) {
            return;
        }
        setToDate(value);
    };

    const handleWorkspaceSelectorChange = (e, selectedValue) => {
        setWorkspaceSelected(selectedValue.value)
    }

    const handleDeleteCalendarEvents = () => {
        deleteCalendarEvents(
            workspaceSelected,
            {
                date_from: toUTC(fromDate + "T00:00:00", workspaceTimeZone, "YYYY-MM-DDTHH:mm:ss"),
                date_to: toUTC(toDate + "T23:59:59", workspaceTimeZone, "YYYY-MM-DDTHH:mm:ss") 
            }
        )
    }

    const renderDeleteModal = () => {
        if(!deleteAction) {
            return null
        }
        return (
            <Modal open>
                <Modal.Header>
                    {t("account.adminConsole.removeDates")} {t("analytics.fromDate").toLowerCase()} {fromDate} {t("analytics.toDate").toLowerCase()} {toDate} 
                </Modal.Header>
                <Modal.Content>
                <Form
                    onSubmit={(e) => {
                    e.preventDefault();
                    if (e.target["confirm-text"].value.toLowerCase() === t("account.adminConsole.confirm").toLowerCase()) {
                        handleDeleteCalendarEvents()
                        setDeleteAction(false)
                        setFromDate("")
                        setToDate("")
                    } else {
                        setWorkspaceNameError({
                        content: t(
                            "account.adminConsole.notMatch"
                        ),
                        pointing: "above",
                        });
                    }
                    return;
                    }}
                >
                    <Form.Input
                        required
                        error={workspaceNameError}
                        onChange={() => setWorkspaceNameError()}
                        label={t("account.adminConsole.removeDatesLabel")}
                        placeholder={t("account.adminConsole.confirm").toUpperCase()}
                        name="confirm-text"
                    />
                    <div className="create-workspace-form-buttons">
                    <Button 
                        // disabled={false} 
                        type="submit" negative
                    >
                        {t("account.adminConsole.delete")}
                    </Button>
                    <Button
                        // disabled={false}
                        onClick={() => {
                            setDeleteAction(false)
                        }}
                    >
                        {t("cancel")}
                    </Button>
                    </div>
                </Form>
                </Modal.Content>
            </Modal>
        );
    }
    return (
        <Grid.Row columns={4}>
            {renderDeleteModal()}
            <Grid.Column width={3} textAlign="left" verticalAlign="bottom" flex={1}>
                <div style={{
                    display: "flex",
                    alignItems: "center"
                }}>
                    <label>
                        {t("account.adminConsole.deleteCalendarEvents")}
                    </label>
                    <Popup content={t("account.adminConsole.deleteCalenderEventsDisclaimer")} 
                        trigger={
                            <span
                            style={{
                                marginLeft: 10,
                                backgroundColor: "#E0E1E2",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: 20,
                                height: 20,
                                borderRadius: "50%"
                            }}
                            >
                                <Icon name="info" size="small" />
                            </span>
                        } 
                    />
                </div>
            </Grid.Column>
            <Grid.Column width={4}>
                <label style={{ textAlign: "left" }}>{t("account.adminConsole.workspaces")}</label>
                <Dropdown 
                    placeholder={t("demand.itemDescription")}
                    fluid
                    value = {workspaceSelected}
                    onChange={handleWorkspaceSelectorChange}
                    // disabled={fetchingData}
                    search selection 
                    options={mapCurrentUserToWorkspaceOptions(workspaces, currentUser)}
                />
            </Grid.Column>
            <Grid.Column width={3}>
                <label style={{ textAlign: "left" }}>{t("analytics.fromDate")}</label>
                <Input
                    type="date"
                    value={fromDate}
                    onChange={handleFromDateChange}
                    fluid
                    className="date-input"
                    max={today}
                />
            </Grid.Column>
            <Grid.Column width={3}>
                <label style={{ textAlign: "left" }}>{t("analytics.toDate")}</label>
                <Input
                    type="date"
                    value={toDate}
                    onChange={handleToDateChange}
                    fluid
                    className="date-input"
                    min={fromDate || undefined}
                />
            </Grid.Column>
            <Grid.Column width={3} textAlign="left" verticalAlign="bottom">
                <Button
                    negative
                    size="small"
                    className="workspace-row-left-button"
                    fluid
                    onClick={() => setDeleteAction(true)}
                    disabled={!fromDate || !toDate}
                >
                    {t("account.adminConsole.removeDates")}
                </Button>
            </Grid.Column>
        </Grid.Row>
  );
};

DeleteCalendarEvents.propTypes = {
    currentWorkspaceId: PropTypes.number,
    deleteCalendarEvents: PropTypes.func,
    currentUser: PropTypes.object.isRequired,
    workspaces: PropTypes.arrayOf(PropTypes.object),
};

DeleteCalendarEvents.defaultProps = {
    deleteCalendarEvents: {},
};

const mapStateToProps = (state) => ({
    currentWorkspaceId: getSafeSelectedWorkspace(state),
    currentUser: state.auth.user,
    workspaces: state.workspace.workspaces,
});
export default connect(mapStateToProps, {
    deleteCalendarEvents
})(DeleteCalendarEvents);